import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Field, Form, Formik, FieldArray, FieldArrayRenderProps, useFormik } from 'formik';
import * as Yup from "yup";
import { CircularProgress } from '@mui/material';
import useUtils from "../../../../utiles/useUtiles";

interface Props {
  csvUUID: string | null
}
type FormType = ReturnType<typeof useFormik>

function validateMathematicalExp(value: string) {
  let error;
  var regex = /{{.*?}}/gi;
  if ( value ) {
    value = value.replace(regex, '1');
    const isValid = isValidMathExpression(value);
    if ( !isValid ) {
      error = 'Invalid mathemetical expression';
    }
  }
  return error;
}

function isValidMathExpression(expression: string) {
  try {
    // Attempt to evaluate the expression
    eval(expression);
    return true; // If eval succeeds, the expression is valid
  } catch (error) {
    return false; // If eval throws an error, the expression is invalid
  }
}

const ColumnMapping: React.FC<Props> = ( { csvUUID } ): JSX.Element => {

  const navigate = useNavigate();
  const { axiosRequest, baseUrl, toastInstance } = useUtils()
  const axios = axiosRequest();
  const toast = toastInstance();

  const [csvDetails, setCsvDetails] = useState<any | null>( null );
  const [csvTypeDetails, setCsvTypeDetails] = useState<any>( {
      csv_type: null,
      columns: { count: 0, rows: [] }
  } );
  const [loading, setLoading] = useState<boolean>( false );
  const formikRef = useRef<any>(null);

  useEffect( () => {
    fetchCsvDetails();
    // fetchCsvTypeDetails();
  }, [] );

  useEffect( () => {
    if ( csvDetails ) {
      fetchCsvTypeDetails();
    }
  }, [csvDetails] );

  const fetchCsvDetails = async () => {
    setLoading( true );
		const request = await axios.get( `${baseUrl()}/template/uploaded/csv-details/${csvUUID}` );
    const { error, result, message } = request.data;
    setLoading( false );

		if ( error ) {
			toast.error( message );
		} else {
			setCsvDetails( result );
		}
	};

  const fetchCsvTypeDetails = async () => {
    setLoading( true );
		const request = await axios.get( `${baseUrl()}/template_types/${csvDetails?.csvType?.id}?page=0&pageSize=100` );
    const { error, result, message } = request.data;
    setLoading( false );
		if ( error ) {
			toast.error( message );
		} else {
			setCsvTypeDetails( result );
		}
	};

  const handleFormSubmit = async ( values: any ) => {
		setLoading( true );
		const request = await axios.post( `${baseUrl()}/template/add/${csvUUID}`, values );
    const { error, result, message } = request.data;
		setLoading( false );

		if ( error ) {
			toast.error( message );
		} else {
			toast.success( message );
      navigate( `/csv-tool/templates` );
		}
	};

  const addExpression = (form: FormType, field: string, text: string) => {
    const value = form.getFieldProps(field)['value']
    form.setFieldValue(field, value && value +' {{'+ text +'}} ' || ' {{'+ text +'}} ');
  }

  useEffect( () => {
    if ( csvDetails && csvTypeDetails ) {
      if ( formikRef.current && csvDetails && csvTypeDetails['columns'] && csvTypeDetails['columns']['rows'].length ) {
        // const header = csvDetails['csv'] && csvDetails['csv']['headers'] && csvDetails['csv']['headers'][0] || '';
				formikRef.current.setFieldValue(
				  "columnMapping",
				  csvTypeDetails['columns']['rows'].map((e: any) => ( {
            "csvTypeColumnId": e.id,
            "csvTypeColumnName": e.name,
            "csvTypeColumnType": e.columnType,
            "csvTypeColumnTypeSelected": '1',
            "templateColumnName": ''
          } ) )
				);
			}
    }
  }, [ csvDetails,csvTypeDetails ] );

  return (
    <>
        {/* <div className="logo mb-3">
          <img src="assets/img/logo-min.png" />
        </div> */}
        <div className="main-card revrex-data-table-card">
          <h1 className="text-center mb-4">Data Uploading Process</h1>
          <div className="mb-3 d-flex flex-nowrap justify-content-between">
            <div className="w-50">
              <h4>Database Field</h4>
            </div>
            <div className="headers-mapping-max-width">
              <h4>CSV Header</h4>
            </div>
          </div>
          <Formik
            innerRef={formikRef}
            initialValues={{
              columnMapping: []
            }}
            // validateOnChange={true}
            // validateOnBlur={true}
            // validationSchema={TemplateStep2FormValidation}
            onSubmit={async ( values, helpers ) => {
              const params = values['columnMapping'].map((e: any) => ({
                "csvTypeColumnId": e.csvTypeColumnId,
                "templateColumnName": e.templateColumnName,
                "isToEvaluate": !+e.csvTypeColumnTypeSelected
              }));
              handleFormSubmit({
                columnMapping: params
              });
            }}>
            {( form: any ) => (
              <Form>
                <FieldArray name="columnMapping">
                    {(arrayHelpers: FieldArrayRenderProps) => (
                      <div>
                          {form.values.columnMapping.map( ( item: any, index: number ) => (
                            <div key={index}>
                              <div>
                                  <div className="mb-3 d-flex flex-nowrap justify-content-between">
                                    <div className="w-50">
                                      <h5>{item.csvTypeColumnName}</h5>
                                    </div>
                                    {
                                      item.csvTypeColumnType === 0 && (
                                        <div className="w-50 d-flex">
                                          <div className='form-check mr-4'>
                                              <Field type="radio" name={`columnMapping.${index}.csvTypeColumnTypeSelected`} value="1" className='form-check-input' id={`columnMapping.${index}.csvTypeColumnTypeSelected_1`} />
                                              <label htmlFor={`columnMapping.${index}.csvTypeColumnTypeSelected_1`} className='form-check-label'>
                                                  Set Header
                                              </label>
                                          </div>
                                          <div className='form-check'>
                                              <Field type="radio" name={`columnMapping.${index}.csvTypeColumnTypeSelected`} value="0" className='form-check-input' id={`columnMapping.${index}.csvTypeColumnTypeSelected_0`} />
                                              <label htmlFor={`columnMapping.${index}.csvTypeColumnTypeSelected_0`} className='form-check-label'>
                                                  Enter Function
                                              </label>
                                          </div>
                                        </div>
                                      )
                                    }
                                    
                                    {
                                      item.csvTypeColumnTypeSelected == 1 && (
                                        <div className="headers-mapping-max-width">
                                          <Field data-cy={`selectColumnMapping.${index}.templateColumnName`} as="select" name={`columnMapping.${index}.templateColumnName`} className="form-control">
                                            <option value={''} selected={true}>{'---'}</option>
                                            {
                                              csvDetails && csvDetails['csv']['headers'] && csvDetails['csv']['headers'].length && csvDetails['csv']['headers'].map((header: string, columnIndex: number ) => (
                                                  <option key={columnIndex} value={header} >{header}</option>
                                              ) )
                                            }
                                          </Field>
                                        </div>
                                      ) || (
                                        <div className="headers-mapping-max-width">
                                          <Field data-cy={`selectColumnMapping.${index}.templateColumnName`} as="input" name={`columnMapping.${index}.templateColumnName`} className="form-control" validate={validateMathematicalExp}>
                                          </Field>
                                          <span className="text-danger small">** Do not include any {'{}'} parenthesis here to avoid technical issue</span>
                                          {form.errors[`columnMapping`] && form.errors[`columnMapping`][index] && form.errors[`columnMapping`][index]['templateColumnName'] && <div className="text-danger">{form.errors[`columnMapping`] && form.errors[`columnMapping`][index] && form.errors[`columnMapping`][index]['templateColumnName']}</div>}
                                        </div>
                                      )
                                    }
                                  </div>
                                  {
                                    item.csvTypeColumnTypeSelected == 0 && (
                                      <div className="headers-panel">
                                        <h4>The headers are</h4>
                                        {
                                          csvDetails['csv'] && csvDetails['csv']['headers'] && csvDetails['csv']['headers'].map((e: string) => (
                                              <div className="cursor-pointer header-tags" onClick={() => addExpression(form, `columnMapping.${index}.templateColumnName`, e)}>
                                                <span>{e} &nbsp;</span>
                                              </div>
                                          ))
                                        }
                                      </div>
                                    )
                                  }
                              </div>
                            </div>
                          ) )}
                        </div>
                    )}
                </FieldArray>
      
                <button data-cy="btnSubmit" type="submit" className="btn btn-md revrex-primary-btn mt-3" disabled={loading}>
                  <span>{ loading && ( <CircularProgress size={20} color={'success'} /> ) || 'Save' }</span>
                </button>
              </Form>
				    )}
			    </Formik>
        </div>
    </>
  );
}

export default ColumnMapping